module.exports = __webpack_public_path__ + "assets/img/3.aebff93d.jpg";